import './ui.sass'
import './math.coffee'
import '!file-loader?name=[name].png!./assets/thumb.png'
import { Game } from './game.coffee'
import { MainMenu } from './menu.coffee'
import { gl, setContext } from './gl.coffee'
import { init, colors, buffers, View } from './view.coffee'
import { throttle, toggleFullScreen, httpGet } from './tools.coffee'
import proto from '../proto.bw.coffee'

bannerAd = (cmd) -> aiptag.cmd.display.push -> aipDisplayTag[cmd] 'zorelit-io_300x250'
bannerAd 'display'
bannerAd 'refresh'

# adplayer = null
# aiptag.cmd.player.push ->
# 	adplayer = new aipPlayer
# 		AD_FULLSCREEN: true
# 		LOADING_TEXT: 'loading advertisement'
# 		PREROLL_ELEM: -> document.getElementById 'preroll'
# 		AIP_COMPLETE: -> joinGame()
# 		AIP_REMOVE: ->

window.addEventListener 'beforeunload', (e) -> if view?.game
	e.returnValue = 'If you leave you will lose your progress.'

do window.onhashchange = ->
	id = if location.hash then location.hash.slice 1 else 'content'
	for t in document.getElementsByTagName('main')[0].children
		t.style.display = t.id == id and 'block' or 'none'

playerInfo =
	name: localStorage.name or ''
	ship: parseInt(localStorage.ship) or 0
	color0: parseInt(localStorage.color0) or 0
	color1: parseInt(localStorage.color1) or 0

canvas = document.getElementById 'view'

class Stats
	constructor: ->
		@reset()
		@fps = @tps = 0
		setInterval =>
			@fps = @frames
			@tps = @ticks
			@reset()
		, 1000
	reset: -> @frames = @ticks = 0

stats = new Stats

game = null
ws = null
view = new View stats
menu = new MainMenu

bindings =
	KeyQ: 0
	KeyW: 1
	Mouse0: 0
	Mouse2: 1
	Space: 'keepDirection'
	Digit1: 'SmileFace'
	Digit2: 'SadFace'
	Digit3: 'WinkFace'
	Digit4: 'EvilFace'
	KeyT: 'InviteToTeam'
	KeyR: 'LeaveTeam'

sendControls = throttle 10, -> if view and ws and ws.readyState == WebSocket.OPEN
	ws.send proto.Controls.pack view.controls
	view.resetControls()

keyDown = {}
handleMove = (ev) -> if view?.game?.player?.ship
	view.aimAt ev.clientX, ev.clientY
	sendControls()
	false

handleKey = (key, state) -> if bindings[key]?
	keyDown[key] = state
	if view?.game?.player?.ship
		k = {}
		for key, state of keyDown when state
			k[bindings[key]] = true
		view.updateControls k
		sendControls()
		false

window.onclose = -> ws.close() if ws
window.ontouchmove = (ev) -> handleMove ev.changedTouches[0]
window.onmousemove = (ev) -> handleMove ev
window.onmousedown = (ev) -> handleKey "Mouse#{ev.button}", true
window.onmouseup = (ev) -> handleKey "Mouse#{ev.button}", false
window.onkeydown = (ev) -> handleKey ev.getCode(), true
window.onkeyup = (ev) ->
	switch ev.getCode()
		when 'Escape' then ws.close() if ws
		when 'BracketRight' then view.showUI = !view.showUI if view
		when 'Backslash' then view.showFPS = !view.showFPS if view
		else handleKey ev.getCode(), false

document.body.onselectstart = -> false
canvas.oncontextmenu = -> false
for event in ['onwheel']
	window[event] = document[event] = -> false
for event in ['ondragstart', 'ondrag', 'ondragend', 'ondragenter', 'ondragover', 'ondragleave', 'ondrop']
	canvas[event] = document.body[event] = -> false

setContext canvas.getContext('webgl') or canvas.getContext('experimental-webgl')
if not gl
	location.hash = '#nowebgl'
	throw new Error 'No WebGL support'

init ->
	menu.setData playerInfo

do window.onresize = ->
	canvas.width = window.innerWidth
	canvas.height = window.innerHeight
	gl.viewport 0, 0, canvas.width, canvas.height
	view.resize canvas.width, canvas.height if view
	if ad = document.getElementById 'zorelit-io_300x250'
		s = document.getElementById('banner').offsetWidth/300
		ad.style.transform = "scale(#{s})"

do draw = ->
	stats.frames += 1
	requestAnimationFrame draw
	if view.game?
		view.draw()
	else
		menu.draw canvas.width, canvas.height

parseRoom = (address) -> if roomAndServer = address.match /\/(\d)\?(\d+)$/i
	[, roomId, serverId] = roomAndServer
	"#{serverId}.#{roomId}"

findServer = (room, onserverfound) ->
	httpGet 'room/' + room, 'text', (address) ->
		address or= "ws://#{location.hostname}:50101/0"
		onserverfound? address, parseRoom address

prefferedRoom = ''

if location.search
	prefferedRoom = if /^\?\d+\.\d$/.test location.search then location.search.slice 1 else ''
	history.replaceState null, '', '/'

updateInvitation = (room) ->
	document.getElementById('room').value = location.host + '/?' + room
	document.getElementById('invite').classList.remove 'hidden'

window.playWithFriends = ->
	document.getElementById('invite').classList.add 'hidden'
	findServer prefferedRoom, (address, room) -> updateInvitation prefferedRoom = room

stopGame = ->
	console.log 'stopGame()'
	prefferedRoom = ''
	view.game = null
	document.getElementById('menu').classList.remove 'hidden'
	document.getElementById('ui').classList.remove 'hidden'
	document.getElementById('respawn').classList.add 'hidden'
	bannerAd 'refresh'

joinGame = ->
	findServer prefferedRoom, (address, room) ->
		updateInvitation room
		ws.close() if ws
		ws = new WebSocket address
		ws.binaryType = 'arraybuffer'
		ws.onopen = -> ws.send proto.PlayerInfo.pack playerInfo
		ws.onclose = -> stopGame()
		ws.onmessage = (b) ->
			stats.ticks += 1
			wasAlive = game?.alive
			game?.tick proto.GameUpdate.unpack b.data
			if wasAlive != game?.alive
				bannerAd 'refresh' if not game?.alive
				document.getElementById('ui').classList.toggle 'hidden', game?.alive
				document.getElementById('respawn').classList.toggle 'hidden', game?.alive
				canvas.classList.toggle 'ingame', game?.alive
				window.focus()
	playerInfo.name = document.getElementById('name').value
	for key, value of playerInfo
		localStorage[key] = value

window.respawn = ->
	view.controls.respawn = true
	sendControls()
	#console.log proto.Controls.create()

window.startGame = ->
	console.log 'startGame()'
	document.getElementById('menu').classList.add 'hidden'
	view.game = game = new Game
	view.resize canvas.width, canvas.height
	localStorage.gamePlays = (+localStorage.gamePlays or 0) + 1
	# if 0 == localStorage.gamePlays % 2
	# 	aiptag.cmd.player.push -> adplayer.startPreRoll()
	# else
	joinGame()



// WEBPACK FOOTER //
// ./client/main.coffee